<template>
  <v-data-table
    class="view-table mt-7"
    :headers="staticData.headers"
    :items="projectsList"
    :items-per-page="-1"
    hide-default-footer
    fixed-header
  >
    <template #item="{item}">
      <ProjectsTableRow
        :class="{'selected-row': item.pinned}"
        :project="item"
        @conditionalDelete="confirmDeleteProject(item)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ProjectsTableRow from '@/components/Projects/ProjectsTableRow.vue';

const headers = [
  { text: '', value: 'avatar', sortable: false },
  { text: 'Nazwa projektu', value: 'name', sortable: false },
  { text: 'ID projektu', value: 'id', sortable: false },
  { text: 'Czas realizacji', value: 'projectPeriod', sortable: false },
  { text: 'Typ projektu', value: 'projectType', sortable: false },
  { text: 'Kampania', value: 'campaign', sortable: false },
  { text: 'Zespół projektowy', value: 'members', sortable: false },
  { text: 'Zespół zlecający', value: 'orderers', sortable: false },
  { text: 'Status', value: 'status', sortable: false },
  { text: '', value: 'actions', sortable: false },
  { text: '', value: 'menu', sortable: false },
];

export default {
  components: {
    ProjectsTableRow,
  },

  data: () => ({
    staticData: {
      headers,
    },
  }),

  computed: {
    ...mapState('projects', ['projectsList']),
  },
  methods: {
    ...mapActions('projects', [
      'softDeleteProject',
      'deleteProjectPermanently',
    ]),

    ...mapActions('dialog', [
      'showDialog',
      'clearDialog',
    ]),

    confirmDeleteProject(project) {
      if (project.status === 'Wersja robocza') {
        this.confirmPermanentDeleteProject(project.id);
        } else {
        this.confirmSoftDeleteProject(project.id);
      }
    },

    confirmSoftDeleteProject(id) {
      this.showDialog({
        header: 'Usuwanie projektu',
        text: '<b>Czy na pewno chcesz przenieść ten projekt do kosza?</b>',
        component: 'Confirm',
        props: {
          confirmText: 'Przenieś',
          rejectText: 'Nie przenoś',
        },
      })
        .then(() => {
          this.softDeleteProject(id).then(() => {
            this.$emit('fetch');
          });
        })
        .catch(() => {
          this.clearDialog();
        });
    },

    confirmPermanentDeleteProject(id) {
      this.showDialog({
        header: 'Trwałe usuwanie projektu',
        text: 'Czy na pewno chcesz trwale usunąć projekt?',
        component: 'Confirm',
        props: {
          confirmText: 'Usuń',
          rejectText: 'Nie usuwaj',
        },
      })
        .then(() => {
          this.deleteProjectPermanently(id).then(() => {
            this.$emit('fetch');
          });
        })
        .catch(() => {
          this.clearDialog();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.selected-row {
  font-weight: 500;
}
</style>
